import React, { useState } from 'react'
import { Carousel } from 'antd'
import {
  SliderContainer,
  SlideContent,
  SlideImage,
  SlideTitle,
  SlideLocation,
  OverlayHeader,
  Title,
} from './styles'

const HistoricWorksSlider: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const titles = [
    { title: 'IE 100 COLEGIO BICENTENARIO', location: 'San Juan de Lurigancho - Lima' },
    { title: 'AEROPUERTO', location: 'Jorge Chávez - Lima' },
    { title: 'CENTRAL PLAZA', location: 'Santa Anita - Lima' },
    { title: 'COLEGIO BICENTENARIO', location: 'Junin - Junin' },
    { title: 'VILLA PRIMAVERA', location: 'ILO - MOQUEGUA' },
    { title: 'CANAL DE RIEGO SANTA ELENA', location: 'PAITA - PIURA' },
  ]

  const images = Array.from({ length: 6 }, (_, i) => `/images/historicWorks/slide${i}.png`)

  return (
    <SliderContainer>
      <OverlayHeader>
        <Title>Obras históricas</Title>
        <span className="subtitle">Hagamos historia juntos</span>
      </OverlayHeader>
      <Carousel
        arrows
        autoplay={{ dotDuration: true }}
        autoplaySpeed={2000}
        dots={true}
        beforeChange={(_, next) => setCurrentIndex(next)}
      >
        {images.map((src, idx) => (
          <div key={idx}>
            <SlideContent>
              <SlideImage style={{ backgroundImage: `url(${src})` }} />
              <div style={{ width: '80%' }}>
                <SlideTitle key={currentIndex}>{titles[idx].title}</SlideTitle>
                <SlideLocation key={`loc-${currentIndex}`}>{titles[idx].location}</SlideLocation>
              </div>
            </SlideContent>
          </div>
        ))}
      </Carousel>
    </SliderContainer>
  )
}

export default HistoricWorksSlider
